import type {ReactElement} from 'react';
import React from 'react';
import styles from '@Panels/stock-panel/components/stock-panel-no-results/stock-panel-no-results.module.scss';
import {Icon} from '@Components/icon-v2';
import {IconShape, IconSize, IconType} from '@Components/icon-v2/icon.types';
import {Text, TextSize, TextType} from '@Components/text';
import Divider from '@Components/divider';
import {ClickableDiv} from '@Components/clickable-div';

export interface StockPanelNoResultsProps {
  className?: string;
  searchTerm: string;
  generationText?: string;
  generationIcon?: string;
  onGenerationTextClicked?(): void;
}

export default function StockPanelNoResults({...props}: StockPanelNoResultsProps): ReactElement<any> {
  const getTextForAction = (): ReactElement<any> | null => {
    return props.generationText ? null : (
      <Text className="content-body text-center" val={window.i18next.t('pmwjs_try_searching_for_a_different_term')} type={TextType.BODY} size={TextSize.SMALL} />
    );
  };

  const getRowForGenerationText = (): ReactElement<any> | null => {
    if (props.generationText && props.generationIcon && props.onGenerationTextClicked) {
      return (
        <span className={`${styles.generationTextRow} flex-h-row flex-center`}>
          <span className={`${styles.gap8} flex-h-row flex-center`}>
            <Icon icon="icon-search" size={IconSize.SIZE_ICON_16} />
            <Text bold type={TextType.BODY} size={TextSize.XSMALL} val={window.i18next.t('pmwjs_try_a_different_term')} />
          </span>

          <Divider height={32} width={1} />

          <ClickableDiv
            className={`${styles.gap8} flex-h-row flex-center _cursor-pointer`}
            onClick={() => {
              if (props.onGenerationTextClicked) {
                props.onGenerationTextClicked();
              }
            }}
          >
            <Icon className={styles.aiGradientIcon} icon={props.generationIcon} size={IconSize.SIZE_ICON_16} />
            <Text className={styles.aiGradientText} bold type={TextType.BODY} size={TextSize.XSMALL} val={props.generationText} />
          </ClickableDiv>
        </span>
      );
    }
    return null;
  };

  return (
    <div className={`_full-width _full-height flex-center flex-v-row ${styles.container} ${props.className ?? ''}`}>
      <div className={`${styles.iconContainer} spacing-p-6 radius-round`}>
        <Icon className="content-body" icon="icon-search" size={IconSize.SIZE_ICON_32} type={IconType.NONE} shape={IconShape.NONE} />
      </div>
      <span>
        <Text
          className="content-body text-center"
          val={`${window.i18next.t('pmwjs_no_results_found_for_search_term', {
            searchTerm: props.searchTerm,
          })} ${props.generationText ? ': ' : '. '}`}
          type={TextType.BODY}
          size={TextSize.SMALL}
        />
        {getTextForAction()}
      </span>
      {getRowForGenerationText()}
    </div>
  );
}
